import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { User } from "../Interface/IUser";
import { useNavigate } from "react-router-dom";
import userIcon from "../images/ICONS.png";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";

type Props = {handleDrawerToggle?: any}
export default function SmallScreenMenu({handleDrawerToggle}: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const [userInfo, setUserInfo] = React.useState<User>({
    id: 0,
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    email: "",
    createdBy: "",
    isActive: true,
    isMDMActive:false,
    roleID: "",
    userType: "",
    token: "",
    passwordResetRequired: false,
    passwordResetAlertMessage: "",
    mdmAccesses:[],
  });

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    if (useEffectCount.current) {
      useEffectCount.current = false;

      if (localStorage.getItem("user-info-lpa") !== null) {
        var currentUser = JSON.parse(
          localStorage.getItem("user-info-lpa") || " "
        );
        if (currentUser !== " ") {
          setUserInfo(currentUser);
        }
      }
    }
  }, []);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseMenu = (link: string) => {
    if (link === "Logout") {
      localStorage.removeItem("user-info-lpa");
      window.location.href = "/";
    } else {
      navigate(link);
    }
    setAnchorEl(null);
    handleDrawerToggle();
  };

  return (
    <>
      {userInfo.id === 0 ? (
        <></>
      ) : (
        <div>
          {" "}
          <p className="user-name-sl">
            Hello {userInfo.firstName} {userInfo.lastName}
          </p>
          <MenuItem onClick={() => handleCloseMenu("Services")}>
            <Avatar /> Home
          </MenuItem>
          <Divider />
          {userInfo.userType == "Admin" ? (
            <>
              <MenuItem onClick={() => handleCloseMenu("UserList")}>
                <ListItemIcon>
                  <PersonAdd fontSize="small" />
                </ListItemIcon>
                Manage Users
              </MenuItem>
              <MenuItem onClick={() => handleCloseMenu("ServicesList")}>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Manage Services
              </MenuItem>
              <MenuItem onClick={() => handleCloseMenu("RoleList")}>
                <ListItemIcon>
                  <DisplaySettingsIcon fontSize="small" />
                </ListItemIcon>
                Manage Roles
              </MenuItem>
            </>
          ) : (
            <></>
          )}
          {userInfo.userType == "External User" ? (
            <MenuItem onClick={() => handleCloseMenu("ResetPassword")}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              Reset Password
            </MenuItem>
          ) : (
            <></>
          )}
          <MenuItem onClick={() => handleCloseMenu("Logout")}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
          {/* </Menu>*/}
        </div>
      )}
    </>
  );
}
